
import React, { useEffect } from "react";
import "./Register_Banner.css"
import Yellow_Btn from '../../common/common_btn/yellow_btn/Yellow_Btn';
import { useNavigate } from 'react-router-dom';
import { AllGetSpandan_Banner } from '../../../features/admin/spandan/Slice';
import { useDispatch, useSelector } from 'react-redux';
import { IDS } from "../../../utils/IDS";
function Register_Banner() {
  const navigate = useNavigate()

  const dispatch = useDispatch();

  const all_spandan_banner = useSelector((state) => state.spandan.all_spandan_banner);


  useEffect(() => {
    dispatch(AllGetSpandan_Banner());
  }, [dispatch]);

  return (
    <>
      <section className='Register_Banner_holder'>
        <div className="container">
          <div className='Register_Banner ' >
            <div className="banner_img_holder">
              <img src={`${IDS.IMG_URL + all_spandan_banner[1]?.image}`} className='banner_img' />
            </div>
            <div className="content_hodler">
              <h5>Join The Scared Flow <br />
                Join For The  Spandan Today</h5>
              <div className="Register_btn">
                <Yellow_Btn
                  btnText={"Register Now!"}
                  className='zoom_in_out'
                  onClick={() => { navigate("/spandan-register-form") }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Register_Banner;

